<template>
  <div class="card mb-4">
    <div class="card-header">
      <i class="fa-regular fa-magnifying-glass me-2"/>検索
    </div>
    <div class="card-body" :class="formClass">
      <div class="text-start">
        <label for="" class="ms-1">キーワード</label>
        <input
          type="text"
          class="form-control form-control-sm"
          :value="keyword"
          @input="$emit('update:keyword', $event.target.value)"
          :placeholder="keywordPlaceholder">
      </div>
      <div class="text-start mt-2">
        <label for="" class="ms-1">ステータス</label>
        <select
          class="form-control form-control-sm"
          name="flag"
          id="flag"
          :value="flag"
          @change="$emit('update:flag', $event.target.value)">
          <option
            v-for="(option) of flagOptions"
            :key="option.label"
            :value="option.value">{{ option.label }}</option>
        </select>
      </div>
      <slot name="additional-filters"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminSearchCard',
  props: {
    keyword: {
      type: String,
      default: null,
    },
    keywordPlaceholder: {
      type: String,
      default: '',
    },
    flag: {
      type: [String, Number],
      default: null,
    },
    flagOptions: {
      type: Array,
      required: true,
    },
    formClass: {
      type: String,
      default: '',
    },
  },
  emits: ['update:keyword', 'update:flag'],
};
</script>

<style lang="scss" scoped>
.card {
  border: 2px solid rgba(152, 121, 89, 1);
}
</style>
